import React from 'react';


export function KonnektBranding() {
  return (
    <span className="konnekt-orange">konnekt</span>
  );
}
